import { format, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

// date-fns throws on an invalid date; show the raw value (or '-') instead of crashing the page
const isValidDate = (d: Date) => !Number.isNaN(d.getTime());
const fallback = (date: unknown) => (typeof date === 'string' && date ? date : '-');

export function fDate(date: Date | string | number) {
  const d = new Date(date);
  return isValidDate(d) ? format(d, 'dd MMMM yyyy') : fallback(date);
}

export function fDateTime(date: Date | string | number) {
  const d = new Date(date);
  return isValidDate(d) ? format(d, 'dd MMM yyyy p') : fallback(date);
}

// The backend checks "today" (promo expiry, poll dates) in Asia/Kolkata, not UTC.
// en-CA formats as YYYY-MM-DD, the same shape the API uses for dates.
export function todayInIndia() {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

export function fToNow(date: Date | string | number) {
  const d = new Date(date);
  if (!isValidDate(d)) return fallback(date);
  return formatDistanceToNow(d, {
    addSuffix: true,
  });
}
